import { createContext } from 'react'

import { ShortcutProviderContextInterface } from './types'

export const ShortcutProviderContext = createContext<
  ShortcutProviderContextInterface | undefined
>(undefined)
